import common from '@/store/common/mutations';
import * as types from './mutation-types';
import moment from 'moment';
import { SEARCH_PARAMS, GROUPS } from './state';

let searchDate = moment().startOf().format('YYYYMM');

//화면 진입시 초기화

export default {
	...common,
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.groups = GROUPS();
		state.partTypeList = [
			{
				"commCd": "MEA",
				"commCdName": "MEA",
				"commCdType": "PART_G"
			},
			{
				"commCd": "EGA",
				"commCdName": "EGA",
				"commCdType": "PART_G"
			}
		], 
		state.mdjTbList = [];
		state.ngType = [];
		state.ngItem = {};
		state.dayCols = [];
		state.pieChartLabel = [];
		state.pieChartData = [];
		state.barChartLabel = [];
		state.barChartData = [];
		state.ngCdList = [];
		state.ngCauseList = [];
		state.isLoading = false; 
		state.maxbarVal = 100;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.GROUPS]: (state, { key, value }) => {
		state.groups[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	}
};
